import "./Main.css";
import NavBar from "../Components/NavBar";
import Carousel from "../Components/Carousel";
import Events from "../Components/Events";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Main()
{   
    const nav = useNavigate();

    useEffect(() => {
        if(window.location.href.split("?")[1] != null)
        {
            const code = window.location.href.split("?")[1].split("&")[0].split("=")[1];
            console.log(code);
            let url = "https://favapis.raganindustries.com/api_dauth_login.php";
            let headers = {
                "Accept" : "application/json",
                "Content-type" : "application/json"
            };
            let values = {
                code : code
            };
            fetch(url, {
                method : 'POST',
                headers : headers,
                body : JSON.stringify(values)
            }).then((response) => response.json()).then((data) => {
                const email = data.email;
                const name = data.name;
                const phone = data.phone;
                const roll = email.split("@")[0];
                window.sessionStorage.setItem("email", email);
                window.sessionStorage.setItem("roll", roll);
                window.sessionStorage.setItem("phone", phone);
                window.sessionStorage.setItem("name", name);
                nav("/inductions");
            });
        }
    }, []);

    return(
        <div className = "main_page">
            <NavBar />
            <Carousel />
            <br/>
            <Events />
        </div>
    );
}

export default Main;